import React, { FunctionComponent } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.common.white,
    position: "relative",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.up("sm")]: {
      height: "80vh",
      minHeight: 500,
      maxHeight: 1300,
    },
  },
  container: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(14),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  backdrop: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.5,
    zIndex: -1,
  },
  background: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    zIndex: -2,
    backgroundImage: (props: SplashImageView) =>
      `url(${props.backgroundImage})`,
    backgroundColor: (props: SplashImageView) => props.loadingColor,
    backgroundPosition: "center",
  },
  arrowDown: {
    position: "absolute",
    bottom: theme.spacing(4),
  },
}));

interface SplashImageView {
  backgroundImage: string;
  loadingColor: string;
}

const SplashImageView: FunctionComponent<SplashImageView> = (props) => {
  const classes = useStyles(props);
  const { backgroundImage, children } = props;

  return (
    <section className={classes.root}>
      {/* Increase the network loading priority of the background image. */}
      <img
        style={{ display: "none" }}
        src={backgroundImage}
        alt="increase priority"
      />
      <Container className={classes.container} maxWidth="sm">
        {children}
        <div className={classes.backdrop} />
        <div className={classes.background} />
        <img
          className={classes.arrowDown}
          src="/productHeroArrowDown.png"
          height="16"
          width="12"
          alt="arrow down"
        />
      </Container>
    </section>
  );
};

export default SplashImageView;
